import React, { Component } from "react";
import PropTypes from "prop-types";

import "../../../styles/components/utils/components/UserCard.scss";
import friends from "../../../styles/images/friends.svg";
import avatar from "../../../styles/images/avatar.svg";
import cross from "../../../styles/images/cross.svg";
import deleteIcon from "../../../styles/images/trashcan.svg";


class GroupCard extends Component {
  render() {
    return (
      <div
        id="userCard"
        className={`card ${this.props.className ? this.props.className : ""} ${
          this.props.type ? this.props.type : ""
        }`}
      >
        <div className="main-container">
          <img
            className="avatar"
            src={
                this.props.avatar
                ? this.props.avatar
                : this.props.type === "period"
                ? avatar
                : friends
            }
            alt=""
          />
          <div className="name-container">
            <p className="name">{this.props.name}</p>
          </div>
          {this.props.onDelete && (
            <div className="cross-container">
              <button type="button" className="clear" onClick={this.props.onDelete}>
                {
                  this.props.evSpecs ? 
                  <img src={deleteIcon} alt="" /> : <img src={cross} alt="" />
                }
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

GroupCard.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  info: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  onDelete: PropTypes.func,
};

export default GroupCard;
